<template>
  <ion-header>
    <ion-toolbar>
      <ion-item lines="none">
        <ion-title>{{ $t('editBooking') }}</ion-title>
        <ion-icon slot="end" style="font-size: 30px;" @click="closeDialog()" :ios="closeOutline" :md="closeOutline" name="closeOutline"></ion-icon>
      </ion-item>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-padding">
    <ion-card>
      <ion-card-header>
        <ion-card-title v-if="slot">
          {{ dayjs(slot.date).format('DD.MM.YYYY HH:mm') }} {{ selectedPro.selectedItem.name }}
        </ion-card-title>
      </ion-card-header>
      <ion-list  v-show="selectedPro" lines="full" class="ion-no-margin">
        <ion-item>
          <ion-icon slot="start" :ios="arrowForwardCircleOutline" :md="arrowForwardCircleOutline"></ion-icon>
          <ion-select v-if="selectedPro" interface="popover" slot="start" v-model="selectedInterval">
            <ion-select-option v-for="(item, index) in selectedPro.interval_selection" :key="index" :value="item">{{ item }}</ion-select-option>          
          </ion-select>
          <ion-label  v-if="selectedPro" slot="start">{{ selectedPro.interval_name }}</ion-label>
        </ion-item>
        <ion-item>
          <ion-label v-if="selectedPro">{{ selectedPro.interval_hint }}</ion-label>
        </ion-item>
        <ion-item v-if="slot && slot.priceFloat > 0">
          <h3>{{ $t('amountToPay') }}: {{ slot.priceFloat * selectedInterval * selectedPro.intervalDivisor }} {{ slot.currencySymbol }}</h3>
          <ion-checkbox v-if="selectedPro && selectedPro.paymentEnabled" :disabled="slot.forceProPayment && slot.payProfee" v-model="slot.payProfee" slot="end"></ion-checkbox>
        </ion-item>
        <ion-item v-show="slot && selectedPro.paymentEnabled && slot.payProfee && slot.priceFloat > 0">
          <ion-label position="stacked">{{ $t('makeAndPayProBooking')}}</ion-label>
          <div style="margin-top: 5px;" id="paypalButton"></div>
          <!-- <ion-select style="min-width: 100% !important;" interface="popover" v-model="paymenttype" :value="paymenttype">
            <ion-select-option v-if="isSuccessfullBraintreePaypalAuthorized" value="PayPalAccount">{{ $t('paypalPayment') }}</ion-select-option>  
            <ion-select-option v-if="isSuccessfullBraintreeCreditCardAuthorized" value="CreditCard">{{ $t('creditCardPayment') }}</ion-select-option>  
          </ion-select>-->
        </ion-item>
        <ion-button v-if="(selectedPro && !selectedPro.paymentEnabled) || (slot && !slot.payProfee)" style="margin-top: 15px;" expand="block" color="primary" @click="doBooking()">{{ slot.payProfee && selectedPro.paymentEnabled ? $t('makeAndPayProBooking') : $t('makeProBooking') }}</ion-button>
      </ion-list>
    </ion-card>
  </ion-content>
</template>

<script>
import { IonButton, IonContent, IonHeader, IonTitle, toastController, IonSelect, IonSelectOption,
IonToolbar, IonLabel, IonInput, IonItem, IonList, IonIcon, IonItemDivider, loadingController,
IonGrid, IonCol, IonRow, modalController, IonCheckbox, IonCard, IonCardHeader, IonCardTitle } from '@ionic/vue';
import { defineComponent, ref } from 'vue';
import { closeOutline, pawSharp, stopCircleOutline, logInOutline, squareSharp, personSharp, 
          personAddOutline, trashOutline, timeOutline, arrowForwardCircleOutline } from 'ionicons/icons';
import { useMutation } from '@vue/apollo-composable'
import saveProBookingMutationFile from '../../graphql/saveProBooking.mutation.gql'
import createPaymentMutationFile from '../../graphql/createPayment.mutation.gql'
import * as dayjs from 'dayjs';
import { loadScript } from "@paypal/paypal-js";
import { getClubInfo } from '@/composition'

export default defineComponent({
  name: 'EditProBookingDialog',
  components: { IonButton, IonContent, IonHeader, IonTitle, IonToolbar,IonLabel, IonInput, IonItem, 
                IonList, IonIcon, IonGrid, IonCol, IonRow, IonItemDivider, IonCheckbox, IonCard, IonCardHeader,
                IonCardTitle, IonSelect, IonSelectOption,
              },
  props: ['propsData'],
  setup() {
    let slot = ref()
    let selectedPro = ref()
    let selectedInterval = ref(0)
    const clubInfo = ref(getClubInfo())

    const { mutate: saveProBookingMutation } = useMutation(saveProBookingMutationFile, { fetchPolicy: 'no-cache' });
    const { mutate: createPaymentMutation } = useMutation(createPaymentMutationFile, { fetchPolicy: 'no-cache' });

    return {
      saveProBookingMutation, 
      dayjs,
      closeOutline, pawSharp, stopCircleOutline, logInOutline, squareSharp, personSharp, personAddOutline,
      trashOutline,timeOutline, slot, selectedPro, selectedInterval, arrowForwardCircleOutline, createPaymentMutation, clubInfo
    }
  },
  computed: {
      isSuccessfullBraintreePaypalAuthorized : function(){ return this.$store.getters.isSuccessfullBraintreePaypalAuthorized},
      isSuccessfullBraintreeCreditCardAuthorized : function(){ return this.$store.getters.isSuccessfullBraintreeCreditCardAuthorized },
      paymenttype : function(){ 
        return 'PayPalAccount'
/*        if (this.isSuccessfullBraintreePaypalAuthorized && this.isSuccessfullBraintreeCreditCardAuthorized )
          return 'PayPalAccount'
        else if (this.isSuccessfullBraintreePaypalAuthorized)
          return 'PayPalAccount'
        else if (this.isSuccessfullBraintreeCreditCardAuthorized)
          return 'CreditCard' */
       },
  },
  mounted() {
    this.slot = this.propsData.slot
    this.selectedPro = this.propsData.selectedPro
    this.selectedInterval = this.selectedPro.interval_selection[0]

    loadScript({ "client-id": "AQe-1_UiC8WAkzp_FORkgq6UT6rRyNqXv2g74Q7ZczFrEIGCwAG65v6m6W3BcNNamN7gtuoNfahiRH0v", currency: this.clubInfo.clubInfo.currency }).then((paypal) => {
    paypal.Buttons({
        style: {
          shape: 'rect',
          color: 'blue',
          layout: 'vertical',
          label: 'pay',
          
        },
        createOrder: async () => {
          const price = this.slot.payProfee ? (this.slot.priceFloat * this.selectedInterval * this.selectedPro.intervalDivisor) : 0
          const p = await this.createPaymentMutation({  description: this.$t('pro') + " " + this.selectedPro.selectedItem.name, amount: parseFloat(price), paymentType: 'payPal' })
          if (!p.data.createPayment.success) {
            return ''
          }
          return p.data.createPayment.token
         },
         onError: async () => {
            toastController
              .create({
                message: this.$t('invalidPayment'),
                duration: 3000,
                color: 'danger'
              }).then(res => res.present())
         },
         onApprove: async (data,actions) => {
            this.buttonDisabled = true
            loadingController.create().then(res => {
              res.present()
            }).catch(err => { })
            this.saveProBookingMutation({ date: this.slot.date, proId: this.selectedPro.selectedItem.id, interval: this.selectedPro.interval_selection.findIndex(i => i == this.selectedInterval) + 1, price: this.slot.payProfee ? (this.slot.priceFloat * this.selectedInterval * this.selectedPro.intervalDivisor) : 0, paymentType: 'PayPalAccount', language: this.$store.getters.language, orderId: data.orderID })
            .then(res => {
                toastController
                  .create({
                    message: this.$t('bookingAdded'),
                    duration: 3000,
                    color: 'success'
                  }).then(res => res.present())
                  loadingController.dismiss()
                  return modalController.dismiss(true)
            })
            .catch(err => {
                loadingController.dismiss()
                toastController
                  .create({
                    message: this.$t('notSuccessful') + ': ' + err,
                    duration: 3000,
                    color: 'danger'
                  }).then(res => res.present())
            }) 
         },
         onCancel: async () => {
          const price = this.slot.payProfee ? (this.slot.priceFloat * this.selectedInterval * this.selectedPro.intervalDivisor) : 0
          await this.createPaymentMutation({ amount: parseFloat(price), paymentType: 'payPalCancel' })
         }
     }).render("#paypalButton") });
  },
  methods: {
    doBooking() {
      loadingController.create().then(res => {
        res.present()
      }).catch(err => { })
      this.saveProBookingMutation({ date: this.slot.date, proId: this.selectedPro.selectedItem.id, interval: this.selectedPro.interval_selection.findIndex(i => i == this.selectedInterval) + 1, price: this.slot.payProfee ? (this.slot.priceFloat * this.selectedInterval * this.selectedPro.intervalDivisor) : 0, paymentType: this.paymenttype, language: this.$store.getters.language })
      .then(res => {
          toastController
            .create({
              message: this.$t('bookingAdded'),
              duration: 3000,
              color: 'success'
            }).then(res => res.present())
            loadingController.dismiss()
            return modalController.dismiss(true)
      })
      .catch(err => {
          loadingController.dismiss()
          toastController
            .create({
              message: this.$t('notSuccessful') + ': ' + err,
              duration: 3000,
              color: 'danger'
            }).then(res => res.present())
      }) 
    },
    closeDialog() {
      return modalController.dismiss()
    },
  }
});
</script>